var _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgİconTabLicence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.272,2.096h-.422c-.348,0-.633.285-.633.609v10.544c0,.372.285.656.609.656h.445c.348,0,.633-.285.633-.633V2.728c0-.348-.285-.633-.633-.633Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.929,2.096c-.232,0-.398.19-.398.398v10.965c-.024.256.19.445.398.445s.422-.19.422-.398V2.494c0-.208-.166-.398-.422-.398Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.054,2.096h-.422c-.348,0-.633.285-.633.609v10.544c0,.372.285.656.609.656h.445c.348,0,.633-.285.633-.633V2.728c0-.348-.285-.633-.633-.633Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.992,
    y: 2.096,
    width: 1.687,
    height: 11.809,
    rx: 0.633,
    ry: 0.633,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.727,2.096c-.232,0-.422.19-.422.422v10.965c0,.232.19.422.422.422s.422-.19.422-.422V2.517c0-.232-.19-.422-.422-.422Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.918,2.096c-.232,0-.422.19-.422.422v10.965c0,.232.19.422.422.422s.422-.19.422-.422V2.517c0-.232-.19-.422-.422-.422Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.578,2.096c-.232,0-.422.19-.422.422v10.965c0,.232.19.422.422.422s.422-.19.422-.422V2.517c0-.232-.19-.422-.422-.422Z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.748,
    y: 2.096,
    width: 1.687,
    height: 11.809,
    rx: 0.633,
    ry: 0.633,
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconTabLicence);
export default __webpack_public_path__ + "static/media/icon_tab_licence.4daa1d358b5f133de7b2dc113c8802e3.svg";
export { ForwardRef as ReactComponent };